import React, {useEffect, useMemo} from "react";
import {routes} from "../../../../core/models/static/routes/app-routes";
import {Typography, useTheme} from "@mui/material";
import {useHistory, useLocation} from "react-router-dom";
import {useEffectOnce} from "react-use";
import {useConfigureNotebook} from "../../../hooks/use-notebook-config";
import useQuery from "../../../hooks/use-query";
import {useAuthenticationState} from "../../../hooks/use-auth-state";


const NotFoundView = () => {
    const [query] = useQuery();
    const theme = useTheme();
    const history = useHistory();
    const location = useLocation();
    const hideBackButton = useMemo(() => query.hideBackButton, [query.hideBackButton]);
    const isRoot = useMemo(() => location.pathname === routes.error.notFound, [location.pathname]);
    const {toggleShow: toggleShowNotebooksAction} = useConfigureNotebook('auth-routes');
    const {loggedIn} = useAuthenticationState();

    /**
     * As soon as the component is mounted, it hides the notebooks feature
     */
    useEffect(() => {
        toggleShowNotebooksAction(false);
    }, [toggleShowNotebooksAction])

    /**
     * checks the url of the pathname, if the notFound section has prefixes, removes them.
     */
    useEffectOnce(() => {
        if (isRoot)
            return;
        history.replace(routes.error.notFound);
    }, [history]);

    return (
        <div
            className={`error-page ${isRoot ? "root" : ''} row no-gutters flex-column flex-md-row justify-content-around justify-content-md-around align-items-center`}>
            <svg width="380px" height="500px" viewBox="0 0 837 1045" version="1.1"
                 xmlns="http://www.w3.org/2000/svg">
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <path
                        d="M353,9 L626.664028,170 L626.664028,487 L353,642 L79.3359724,487 L79.3359724,170 L353,9 Z"
                        id="Polygon-1" stroke={theme.palette.primary.main} strokeWidth="6"/>
                    <path
                        d="M78.5,529 L147,569.186414 L147,648.311216 L78.5,687 L10,648.311216 L10,569.186414 L78.5,529 Z"
                        id="Polygon-2" stroke={theme.palette.tertiary.main} strokeWidth="6"/>
                    <path
                        d="M773,186 L827,217.538705 L827,279.636651 L773,310 L719,279.636651 L719,217.538705 L773,186 Z"
                        id="Polygon-3" stroke={theme.palette.secondary.main} strokeWidth="6"/>
                    <path
                        d="M639,529 L773,607.846761 L773,763.091627 L639,839 L505,763.091627 L505,607.846761 L639,529 Z"
                        id="Polygon-4" stroke={theme.palette.tertiary.main} strokeWidth="6"/>
                    <path
                        d="M281,801 L383,861.025276 L383,979.21169 L281,1037 L179,979.21169 L179,861.025276 L281,801 Z"
                        id="Polygon-5" stroke={theme.palette.secondary.main} strokeWidth="6"/>
                </g>
            </svg>
            <div className="message-box">
                <h1>404</h1>
                <Typography component={'p'} variant={'body2'}>The page you are looking for is no longer here. Maybe it was never here in the first place. In any
                    case, we are sorry you were sent on this wild goose chase, and have already taken steps to have the
                    person responsible fired.
                </Typography>
                {
                    !hideBackButton &&
                    <div className="action-link-wrap d-flex align-items-center justify-content-center">
                        <button onClick={history.goBack} className='animated-button btn'>
                            <span>Sorry again</span><span>Go Back</span>
                        </button>
                        {
                            loggedIn &&
                            <button onClick={() => history.replace(routes.landing)} className='animated-button btn'>
                                <span>Sorry again</span><span>Go to Home</span>
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default NotFoundView;
